export const copyLinkToClipboard = (link) => {
	const textArea = document.createElement('textarea');
	textArea.value = link;
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();
	try {
		document.execCommand('copy');
	} catch (err) {
		console.error('Unable to copy to clipboard', err);
	}

	document.body.removeChild(textArea);
};
